export default __webpack_public_path__ + "static/media/Private 25Jun2021.3f8c9d6b.png";